export const createObserver = (element: HTMLElement, callback: (width: number, height: number) => void) => {
  // TODO ADD TS SUPPORT!
  // @ts-ignore
  const observer = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const { width, height } = entry.contentRect;

      callback(width, height);
    }
  });

  observer.observe(element);

  return observer;
};

// TODO RENAME TO DINEMSIONS
const calculateDimensions = (aspectRatio: number, containerWidth: number, containerHeight: number) => {
  const containerAspectRatio = containerWidth / containerHeight;

  return aspectRatio < containerAspectRatio
    ? {
        width: aspectRatio * containerHeight,
        height: containerHeight,
      }
    : {
        width: containerWidth,
        height: containerWidth / aspectRatio,
      };
};

export const Dimensions = {
  calculateDimensions,
};
